import Api from './rest/ReferralApi';

export default new Api();
